module.exports = function lines(str) {
  if (str == null) return [];
  return String(str).split(/\r\n?|\n/);
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/underscore.string/lines.js
 ** module id = 413
 ** module chunks = 0
 **/